import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { SearchService } from '../../services/search.service';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    imports: [FormsModule]
})
export class TopBarComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  shoppingCartService = inject(ShoppingCartService);
  searchService = inject(SearchService);


  term: string;
  termSubscription: Subscription;

  ngOnInit(): void {
    this.termSubscription = this.searchService.term$.subscribe(term => {
      this.term = term;
    });
  }

  ngOnDestroy(): void {
    if(this.termSubscription) {
      this.termSubscription.unsubscribe();
    }
  }

  handleKeyUp($event): void {
    if($event.keyCode === 13){
      this.searchService.navigate(this.term);
    }
  }
}
